import React from 'react'
import '../SinglePage.scss'
import Text from './Text'

// FUNCTIONAL COMPONENT
const WeAreHiring = () => {
    return (
        <div className="single-page">
            <Text/>
        </div>
    )
}

export default WeAreHiring